import { useCurrentCity } from '@cp/entities/location';
import { useSelector } from 'react-redux';
import { catalogLayoutActiveItemIdSelector } from 'src/features/catalog';
import { coreCatalogItemApi } from '@cp/entities/catalogItem';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { Resume } from 'src/widgets/resume';
import { VacancyView } from 'src/entities/vacancy';
import { Box, Container } from '@cp/ui/components';
import { useHelmet } from 'src/shared/helmet';
import React from 'react';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { useResumeAuthorAgeLabel } from 'src/entities/resume';
import { useDeclination } from '@cp/shared/declination';
import { getResumeGeoPoint } from '@cp/entities/resume';
import { CatalogItemMap } from 'src/entities/catalog';

export const CatalogItem = () => {
  const Helmet = useHelmet();
  const id = useSelector(catalogLayoutActiveItemIdSelector);
  const { currentCity } = useCurrentCity();
  const { data } = coreCatalogItemApi.endpoints.getById.useQuery({ id }, { skip: !currentCity || Number.isNaN(id) });
  const authorAgeLabel = useResumeAuthorAgeLabel(data);
  const declination = useDeclination();

  const metaTags = React.useMemo(() => {
    if (!data) {
      return {
        title: `Анкета специалиста (#${id})`,
        description: '',
      };
    }
    return {
      title: `${[data.clientProfile?.name, data.clientProfile?.surname, data.clientProfile?.patronymic].filter(Boolean).join(' ')}${
        authorAgeLabel ? ` ${authorAgeLabel}` : ''
      }, ${data.city?.translation.name}${
        data.experience ? `, опыт - ${data.experience} ${declination(data.experience, DeclinationMnemonic.Year)}` : ''
      }`,
      description: `Обо мне. ${data?.translation?.description}`,
    };
  }, [authorAgeLabel, data, declination, id]);

  return (
    <Box component="main" sx={{ mt: 5, mb: 10 }}>
      <Helmet>
        <title>{metaTags.title}</title>
        <meta content={metaTags.description} name="description" />
      </Helmet>
      <Container>
        {data.type === CatalogItemType.Resume ? (
          <Resume data={data} />
        ) : (
          <VacancyView data={data} map={<CatalogItemMap location={getResumeGeoPoint(data)} />} />
        )}
      </Container>
    </Box>
  );
};
